export default "__VITE_ASSET__DHoX0WrD__"